import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBuildingBankLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12.555 1.168a1 1 0 0 0-1.11 0l-9 6A1 1 0 0 0 3 9h1.25v7.47c0 .313-.097.647-.189.964q-.044.15-.082.293a6 6 0 0 0-.067.287c-.11.52.306.986.838.986h1c.532 0 .948-.466.838-.986a6 6 0 0 0-.15-.58c-.091-.317-.188-.651-.188-.963V9h2.5v7.47c0 .313-.097.647-.189.964q-.044.15-.082.293a6 6 0 0 0-.067.287c-.11.52.306.986.838.986h1c.532 0 .948-.466.838-.986a6 6 0 0 0-.15-.58c-.091-.317-.188-.651-.188-.963V9h2.5v7.47c0 .313-.097.647-.189.964q-.044.15-.082.293a7 7 0 0 0-.067.287c-.11.52.306.986.838.986h1c.532 0 .948-.466.838-.986a6 6 0 0 0-.15-.58c-.091-.317-.188-.651-.188-.963V9h2.5v7.47c0 .313-.097.647-.189.964q-.044.15-.082.293a7 7 0 0 0-.067.287c-.11.52.306.986.838.986h1c.532 0 .948-.466.838-.986a7 7 0 0 0-.067-.287q-.038-.143-.082-.293c-.092-.317-.189-.651-.189-.963V9H21a1 1 0 0 0 .555-1.832zM12 3.202 17.697 7H6.303z'
      clipRule='evenodd'
    />
    <path fill={props.color} d='M3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z' />
  </svg>
)
const ForwardRef = forwardRef(SvgBuildingBankLine)
export default ForwardRef
